
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { RequestProgressComponent } from './shared/components/request-progress/request-progress.component';
import { ToastHostComponent } from './shared/components/toast-host/toast-host.component';
import { ThemeService } from './shared/service';

@Component({
    selector: 'app-root',
    providers: [],
    imports: [
    RouterOutlet,
    ToastHostComponent,
    RequestProgressComponent
],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly themeService = inject(ThemeService);

  public ngOnInit(): void {
    this.themeService.getTheme();
  }
}
